import React, { useState } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Visualizar, VisualizarProntuario } from '../../../../components/Acoes'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const Consulta = props => {
    const [data, setData] = useState([])
    const history = useHistory()

    const columns = React.useMemo(
        () => [{
            id: 'consulta-prontuario',
            columns: [
                {
                    Header: 'CPF',
                    accessor: 'bene_cpf',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                }, {
                    Header: 'Paciente',
                    accessor: 'paciente',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'beneficiario',
                        idColuna: 'beneficiario.bene_id'
                    }
                }, {
                    Header: 'Prestador',
                    accessor: 'prestador',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'prestador_conselho',
                        idColuna: 'prestador.pres_id'
                    }
                }, {
                    Header: 'Última Consulta',
                    accessor: 'ultima_consulta',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    )

    const maisAcoesObj = [
        (propsAcao) => <VisualizarProntuario action={async () => {
            history.push({ pathname: '/atendimento/prontuario/visualizacao/' + propsAcao.id, state: propsAcao.row })
        }} />,
    ]

    return (
        <>
            <div>
                <DataGridAlternativa acoesObj={maisAcoesObj} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/atendimento/prontuario' caminhoConsultaFiltros='/atendimento/prontuariopaginacao' modulo={props.modulo} titulo={'Consulta Prontuário'}
                    tituloLista={'Lista Prontuário'}
                    urlCadastro='/atendimento/prontuario/cadastro' icone={props.icone} />
            </div>
        </>
    )
}

export default Consulta